// Author Liang Gang Qiang
// Date 2021-11-27 14:54:42

class MintalMesQualityProductionSample {
constructor({
        id = null,
        qualityProductionProjectId = '',
        qualityProductionProjectCode = '',
        code = '',
        name = '',
        sampler = '',
        sampleTime = '',
        confirmor = '',
        confirmTime = '',
        inspectResult = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.qualityProductionProjectId = qualityProductionProjectId;
    this.qualityProductionProjectCode = qualityProductionProjectCode;
    this.code = code;
    this.name = name;
    this.sampler = sampler;
    this.sampleTime = sampleTime;
    this.confirmor = confirmor;
    this.confirmTime = confirmTime;
    this.inspectResult = inspectResult;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualityProductionSample();
}

const inspectVoConfigs = [
        {
        key: 'qualityProductionProjectCode',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.qualityProductionProjectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampler',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.sampler',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.sampleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'confirmor',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.confirmor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'confirmTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.confirmTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectResult',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.inspectResult',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '无' },
                            { value: '1', text: '合格' },
                            { value: '2', text: '一级品' },
                            { value: '3', text: '二级品' },
                            { value: '4', text: '不合格' }
            ],
            customClass: (row) => {
                if (row.inspectResult === 4) {
                    return "text-danger font-weight-bold";
                }
                return "";
            }
        }
        },
        {
        key: 'status',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已保存' },
                            { value: '2', text: '已报检' },
                            { value: '3', text: '已接收' },
                            { value: '4', text: '检验中' },
                            { value: '5', text: '已完成' },
                            { value: '6', text: '复测中' }
            ]
        }
        }
    ]
const createVoConfigs = [
        {
        key: 'qualityProductionProjectCode',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.qualityProductionProjectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampler',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.sampler',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.sampleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectResult',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.inspectResult',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '无' },
                            { value: '1', text: '合格' },
                            { value: '2', text: '一级品' },
                            { value: '3', text: '二级品' },
                            { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'status',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已保存' },
                            { value: '2', text: '已报检' },
                            { value: '3', text: '已接收' },
                            { value: '4', text: '检验中' },
                            { value: '5', text: '已完成' },
                            { value: '6', text: '复测中' }
            ]
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualityProductionProjectCode',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.qualityProductionProjectCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampler',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.sampler',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.sampleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'confirmor',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.confirmor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'confirmTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.confirmTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectResult',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.inspectResult',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '0', text: '无' },
                            { value: '1', text: '合格' },
                            { value: '2', text: '一级品' },
                            { value: '3', text: '二级品' },
                            { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'status',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '已保存' },
                            { value: '2', text: '已报检' },
                            { value: '3', text: '已接收' },
                            { value: '4', text: '检验中' },
                            { value: '5', text: '已完成' },
                            { value: '6', text: '复测中' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    qualityProductionProjectIdFilter : '',
    qualityProductionProjectCodeFilter : '',
    inspectObjectFilter : '',
    inspectTypeFilter : '',
    inspectTypeListFilter : [],
    codeFilter : '',
    nameFilter : '',
    samplerFilter : '',
    sampleTimeRteFilter : '',
    sampleTimeLteFilter : '',
    confirmorFilter : '',
    confirmTimeRteFilter : '',
    confirmTimeLteFilter : '',
    inspectResultFilter : '',
    statusFilter : '',
    statusGtFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'qualityProductionProjectCodeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.qualityProductionProjectCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionProject'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"qualityProductionProjectId": "id"}'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'samplerFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampler',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampleTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sampleTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'confirmorFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.confirmor',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'confirmTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.confirmTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'confirmTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.confirmTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectResultFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.inspectResult',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '无' },
                { value: '1', text: '合格' },
                { value: '2', text: '一级品' },
                { value: '3', text: '二级品' },
                { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '已保存' },
                { value: '2', text: '已报检' },
                { value: '3', text: '已接收' },
                { value: '4', text: '检验中' },
                { value: '5', text: '已完成' },
                { value: '6', text: '复测中' }
            ]
        }
        },
];
const inspectFilterConfigs = [
        {
        key: 'qualityProductionProjectCodeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.qualityProductionProjectCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionProject'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"qualityProductionProjectId": "id"}'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'samplerFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampler',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampleTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sampleTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'confirmorFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.confirmor',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'confirmTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.confirmTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'confirmTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.confirmTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectResultFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.inspectResult',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '无' },
                { value: '1', text: '合格' },
                { value: '2', text: '一级品' },
                { value: '3', text: '二级品' },
                { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '已保存' },
                { value: '2', text: '已报检' },
                { value: '3', text: '已接收' },
                { value: '4', text: '检验中' },
                { value: '5', text: '已完成' },
                { value: '6', text: '复测中' }
            ]
        }
        }
];
const createFilterConfigs = [
        {
        key: 'qualityProductionProjectCodeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.qualityProductionProjectCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionProject'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"qualityProductionProjectId": "id"}'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'samplerFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampler',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampleTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sampleTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.sampleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectResultFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.inspectResult',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '无' },
                { value: '1', text: '合格' },
                { value: '2', text: '一级品' },
                { value: '3', text: '二级品' },
                { value: '4', text: '不合格' }
            ]
        }
        },
        {
        key: 'statusFilter',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '已保存' },
                { value: '2', text: '已报检' },
                { value: '3', text: '已接收' },
                { value: '4', text: '检验中' },
                { value: '5', text: '已完成' },
                { value: '6', text: '复测中' }
            ]
        }
        }
];


    const inspectEntityConfigs = [
        {
        key: 'confirmor',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.confirmor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'confirmTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.confirmTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
]
    const createEntityConfigs = [
        {
        key: 'qualityProductionProjectCode',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.qualityProductionProjectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionProject'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"qualityProductionProjectId": "id"}'
                }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampler',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.sampler',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.sampleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'qualityProductionProjectCode',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.qualityProductionProjectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualityProductionProject'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"qualityProductionProjectId": "id"}'
                }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampler',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.sampler',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.sampleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'confirmor',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.confirmor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'confirmTime',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.confirmTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProductionSample.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualityProductionSample, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs, inspectFilterConfigs, createFilterConfigs
, inspectEntityConfigs, createEntityConfigs
, inspectVoConfigs, createVoConfigs
}
